import { render, staticRenderFns } from "./cModalInsumos.vue?vue&type=template&id=1a5a3e72"
import script from "./cModalInsumos.vue?vue&type=script&lang=js"
export * from "./cModalInsumos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports